<template>
  <div
    v-bind="$attrs"
    :class="baseCardSectionClasses"
    class="base-card-section"
    v-on="$listeners"
  >
    <div 
      v-if="title" 
      class="base-card-section__header"
    >
      <base-subheading 
        :aria-label="title" 
        element="h3"
      >
        {{ title }}
      </base-subheading>
    </div>

    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  variation: {
    type: String,
    default: "base",
    validator: (value) => ["base", "subdued"].includes(value),
  },
  spacing: {
    type: String,
    default: "loose",
    validator: (value) => [
      "none",
      "x-tight",
      "tight",
      "slim",
      "regular",
      "loose",
      "x-loose",
    ].includes(value),
  },
});

const baseCardSectionClasses = computed(() => ({
  [`base-card-section--spacing-${props.spacing}`]: true,
  [`base-card-section--variation-${props.variation}`]: true,
}));
</script>

<style lang="scss">
@import "./base-card-section.scss";
</style>
